import { useState, useRef, useEffect, useCallback } from "react";
import html2pdf from "html2pdf.js";
import { CloudDownload, Print, ViewAgenda } from "@material-ui/icons";
import GroupTable from "../Table";
import Back from "../../../Icon/Back";
import { Button } from "../../Component";

import useScaleToFit from "../../../../hooks/scaleToFit";
import "./download-table.css";

import { getDay, getFormattedDate, getPdfFormatByWidth } from "../../utils";

function DownloadTable(props) {
  const { scale, sectionRef } = useScaleToFit();
  const [loading, setLoading] = useState("");
  const [print, setPrint] = useState(false);
  //const screenRef = useRef();

  const handleDownloadPDF = useCallback(() => {
    if (loading) return;
    setLoading("downloading");
    const element = sectionRef.current;
    const table = sectionRef.current.children[1].children[0];
    const elementWidth = [...table.children].reduce((prev, curr) => {
      prev += curr.clientWidth;
      return prev;
    }, 0); // full width of content
    const elementHeight = window.document.body.scrollHeight; // full height of content

    const config = {
      unit: "pt",
      format: getPdfFormatByWidth(elementWidth),
      orientation: props.view ? "landscape" : "portrait",
    };

    const opt = {
      margin: 0,
      filename: `download.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 3,
        scrollY: 0,
        windowHeight: elementHeight,
      },
      jsPDF: config,
      pagebreak: { mode: "css", before: ".pagebreak" }, // key line
    };

    html2pdf().set(opt).from(element).save();

    setLoading("");
  }, [props.view]);

  function openPrint() {
    setPrint(true);
    const t = setTimeout(() => {
      window.print();
      clearTimeout(t);
    }, 100);
  }

  useEffect(() => {
    function handleAfterPrint() {
      setPrint(false);
    }
    //attach listener
    window.addEventListener("afterprint", handleAfterPrint);
    //remove listener
    return () => {
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, []);

  return (
    <>
      {/* Download button */}
      <div
        style={{
          width: "100%",
          display: print ? "none" : "flex",
          justifyContent: "space-between",
          padding: "0 20px",
          marginTop: "-40px",
        }}
      >
        <Back
          backPath={props.info.role === "teacher" ? undefined : "/lessonplans"}
          click={() => props.updateQuery({ action: "edit" })}
        />
        <div style={{ display: "flex", gap: "30px" }}>
          <Button onClick={props.changeView} style={{ marginLeft: "auto" }}>
            <ViewAgenda
              style={{ transform: !props.view ? "rotate(90deg)" : "" }}
            />
            {!props.view ? "Portrait" : "Landscape"}
          </Button>
          <Button
            disabaled={loading === "downloading"}
            onClick={handleDownloadPDF}
            className="fixed bottom-5 right-5 bg-blue-600 text-black px-4 py-2 rounded"
          >
            <CloudDownload />
            Download
          </Button>
          <Button
            onClick={openPrint}
            className="fixed bottom-5 right-5 bg-blue-600 text-black px-4 py-2 rounded"
          >
            <Print /> Print
          </Button>
        </div>
      </div>
      <div
        ref={sectionRef}
        className="table-scroller"
        style={{
          margin: "0px 20px 20px 20px",
          minHeight: "100%",
          marginTop: print ? "-60px" : "0px",
          transformOrigin: "top left",
        }}
      >
        <div>
          <h1 style={{ textAlign: "center", margin: "20px 0 0 0" }}>
            {props?.info?.schoolName || ""}
          </h1>
          <h4 style={{ textAlign: "center", margin: "20px 0 0 0" }}>
            {"Daily Lesson Plan"}
          </h4>
          <div className="lp-table-info">
            <div>
              Name of the Teacher: <u>{props?.info?.teacherName || "N/A"}</u>
            </div>
            <div>
              Level: <u>{props?.info?.level || "N/A"}</u>
            </div>
            <div>
              Classes Teaching: <u>{props?.info?.classesTeaching || "N/A"}</u>
            </div>
          </div>
          <div className="lp-table-info">
            <div>
              Date:{" "}
              <u>
                {props?.info?.startDate
                  ? getFormattedDate(props.info?.startDate, "-", "DD-MM-YY")
                  : ""}
              </u>
            </div>
            <div>
              Day: <u>{getDay(props.info?.startDate)}</u>
            </div>
          </div>
        </div>
        <GroupTable
          columns={props.columns}
          print={print}
          setPrint={setPrint}
          view={props.view}
          noScroll={true}
        />
        <p
          style={{ fontSize: "0.8rem", textAlign: "center", marginTop: "20px" }}
        >
          Lesson Plan Powered by <a href="https://2xcell.in">2xcell</a>
        </p>
      </div>
    </>
  );
}

export default DownloadTable;
